import { usePdf } from "@mikecousins/react-pdf";
import classNames from "classnames";
import { useEffect, useRef, useState } from "react";
import { GetIco } from "@/utils/icons";
import Button from "@UI/Button";
import s from "./common.module.css";
import openFull from "../../../images/free-icon-fullscreen-158458.png";
import closeFull from "../../../images/free-icon-exit-full-screen-2459633.png";
import { useLocalStorage } from "@hooks";
import { probeApi } from "@api";
import { jsonConvert } from "@/helpers/jsonConvert";
import { useHistory } from "react-router-dom";

import Preloader from "../../UI/Preloader";
import { getInArr } from "@/helpers/getInArr";
import { useAddAlert } from "@hooks/useAddAlert";
import { useDispatch } from "react-redux";
import { actionGetOwnBacklog } from "@store/children/children.reducer";
import { useSelector } from 'react-redux'
import { selectProfile } from '@store/profile.reducer'
import { ShowMode } from "./components/ShowMode";
import Task from "@common/Task";
import { Modal } from "antd";

export const Probes = (props) => {
  if (props.state.status > 4) return <ShowMode {...props} />;
  return <EditMode {...props} />;
};

const EditMode = ({ file, state, ...props }) => {

  const hist = useHistory();

  const [saveLoading, setSaveLoading] = useState(false);
  const addAlert = useAddAlert();
  const dispatch = useDispatch();

  const save = ({data, goBack = true}) => {
    setSaveLoading(true);

    const formData = new FormData();
    formData.append("answers", jsonConvert(data.answers));
 

    probeApi.pass({ id: props.id, data: formData }).then((res) => {
      setSaveLoading(false);
      if (res.data.status === "success") {
        props.setStatus?.("go")
        addAlert({ title: `Ваш пробник успешно отправлен` });
        localStorage.removeItem(`${state.work_id}-userProbeTasks`);
        dispatch(actionGetOwnBacklog());
        if(goBack){
          hist.goBack();
        }
      } else
        addAlert({
          title: `УПС! Возникла ошибка...`,
          text: "Повторите попытку или обратитесь к педагогу",
        });
    });
  };

  return (
    <Body {...{ file, state, save, saveLoading, status: props.status, isTimerExpired: props?.isTimerExpired }} />
  );
};

const Body = ({ state, file, show = false, status, ...props }) => {
  // получаем задания
  const allTasks = [...state?.probeTasks]?.sort((a, b) => a.task_id - b.task_id);
  const tasks = allTasks
    ?.filter((item) => !getInArr(item.task.type, ["file-answer"]));

  const cPath = allTasks
    ?.filter((item) => getInArr(item.task.type, ["file-answer"]));

  // длина строки
  const STRING_LENGTH = 18;

  // создание массива строки
  const createValues = (initValue) => {
    const newArr = [];
    for (let i = 0; i < STRING_LENGTH; i++)
      initValue[i] !== undefined ? newArr.push(initValue[i]) : newArr.push("");
    return newArr;
  };

  // создание строки
  const createRow = (id, initValue) => ({
    id,
    values: createValues(initValue),
  });

  // создание всех строк
  const createTable = (data) => {
    const newArr = [];
    data?.map((item) => newArr.push(createRow(item?.task_id, "")));
    return newArr;
  };
  const [kim, setKim] = useLocalStorage(
    `${state.work_id}-userProbeTasks`,
    createTable(tasks)
  );

  const allCount = kim?.length;
  const leftCount = Math.round(allCount / 2);

  const leftKim = kim?.slice(0, leftCount);
  const rightKim = kim?.slice(leftCount);

  const handleChange = (id, idxCol, value) => {
    setKim((prev) =>
      prev.map((row) => {
        if (row.id === id) {
          const newValues = [...row.values];
          newValues[idxCol] = value;
          return { ...row, values: newValues };
        }
        return row;
      })
    );
  };

  const save = ({goBack=true}) => {
    const dataKim = kim.map(({ values, id }) => {
      let value = "";
      values.forEach((item) => {
        value += item;
      });
      return { task_id: id, answer: value };
    });

    const dataCPath = cPath.map(({ task_id }) => ({ task_id, answer: "" }));

    props.save({data: { answers: [...dataKim, ...dataCPath] }, goBack});
  };

  const savedClickRef = useRef(null);
    
  const handleGlobalClick = (e) => {
    if(!!savedClickRef.current) return;
    if(e.target.closest('.app-sidebar') || e.target.closest(`.buttonPrev`) || e.target.className.includes(`.buttonPrev`)){
      savedClickRef.current = e.target;

      e.preventDefault();
      e.stopPropagation();

      Modal.confirm({
          className: s.confirm,
          title: 'Подтверждение действия',
          content: 'Если вы перейдете на другую страницу, то пробник закроется и вы не сможете его прорешать',
          okText: 'Перейти',
          cancelText: 'Остаться',
          onOk() {
            save({goBack: false});
            e.target.click();
            savedClickRef.current = null;         
          },
          onCancel() {
            savedClickRef.current = null;
          },
          afterClose: () => {
            savedClickRef.current = null;
          }
        }); 
      }
  };

  useEffect(() => {
    if(status == 'start') {
        document.addEventListener('click', handleGlobalClick, {
          capture: true,
          passive: false
      });

      return () => {
        document.removeEventListener('click', handleGlobalClick, true);
      };
    }
  }, [status]);

  const profile = useSelector(selectProfile);

  return (
    <div className={s.wrapper}>
      <MyPdfViewer file={process.env.REACT_APP_PATH_FILE + file} />
      <h2 className={s.kimTaskHeader}>Заполните КИМ по первой части</h2>

      <div className={classNames(s.divTable, "customScroll")}>
        <ColKim {...{ path: leftKim, handleChange, disabled: !!props?.isTimerExpired }} />
        <ColKim {...{ path: rightKim, handleChange, startIdx: leftCount, disabled: !!props?.isTimerExpired }} />
      </div>
      <h2 className={s.kimTaskHeader}>Загрузите решения заданий C части</h2>

      <div className={s.textCenter}>
        <div className={s.list}>
          {state?.probeTasks?.filter((task) => task?.task?.type === 'file-answer').map((item, idx) => (
            <Task
              key={item.id}
              {...{
                type: 'probe',
                props: {
                  ...item.task,
                  category:
                    ((state.status < 5 && !props?.isTimerExpired)) 
                      ? "dz"
                      : "decided",
                },
                title: idx + 1,
                homeWork_id: state.id,
                children_id: state.children_id,
                result: state.probeWorkResults?.find(
                  (i) => +i.task_id === item?.task?.id
                ), 
                status: ( props?.isTimerExpired && state.status < 5 ) ? 5 : state.status,
                redo_homework: false,
                // hist: hist.location.search,
                setStatRowValues: () => {},
              }}
            />
          ))}
        </div>
      </div>

      {
        profile.role !== 'parent' && (
          <div className={s.footerSend}>
            {props.saveLoading ? (
              <Preloader />
            ) : (
              <Button name={"Сдать работу"} action={save} />
            )}
          </div>
        )
      }
    </div>
  );
};

const ColKim = ({ path, handleChange, startIdx = 0, disabled }) => {
  return (
    <div>
      {path?.map((row, idxRow) => (
        <div
          className={classNames(s.row, { [s.rowFirst]: idxRow === 0 })}
          key={idxRow}
        >
          <span className={s.editingInput}>{idxRow + 1 + startIdx}</span>
          {row.values.map((col, idxCol) => (
            <Cell
              key={idxCol}
              value={col}
              onChange={(value) => handleChange(row.id, idxCol, value)}
              disabled={disabled}
            />
          ))}
          {process.env.REACT_APP_DEV_MODE === "1" && (
            <span className="error">{row.id}</span>
          )}
        </div>
      ))}
    </div>
  );
};

const Cell = (props) => {
  const value = props.value ?? "";

  const kd = (e) => {
    const kd = e.target;
    props.onChange(kd.value.toUpperCase());
    let nextKd = kd.nextElementSibling;
    if (kd.value) nextKd?.focus();
  };

  const kdBack = (e) => {
    const kd = e.target;
    if (e.target.value === "" && e.keyCode === 8) {
      props.onChange("");
      let prevKd = kd.previousElementSibling;
      prevKd?.focus();
      if (prevKd) prevKd.value = "";
    }
  };

  return (
    <input
      className={s.editingInput}
      onKeyDown={kdBack}
      onChange={kd}
      value={value}
      type={"text"}
      maxLength={1}
      disabled = {props?.disabled}
    />
  );
};

export const MyPdfViewer = ({ presentation = false, file }) => {
  const [page, setPage] = useState(1);
  const [fullScreen, setFullScreen] = useState(false);
  const canvasRef = useRef(null);
  let canvas = document.getElementById("canvas");
  const { pdfDocument } = usePdf({
    file: file,
    page,
    canvasRef,
    scale: 1.2,
  });
  let elem = document.getElementById("pdf");

  document.addEventListener("fullscreenchange", () => {
    if (document.fullscreenElement) {
    } else {
      setFullScreen(false);
    }
  });

  function openFullscreen() {
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }

    setFullScreen(true);
  }
  if (fullScreen) {
    canvas.style.width = "100%";
    canvas.style.height = "90vh";
  }
  /* Close fullscreen */
  function closeFullscreen() {
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document?.webkitExitFullscreen) {
      /* Safari */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE11 */
      document.msExitFullscreen();
    }
    setFullScreen(false);
  }

  return (
    <div id="pdf">
      <div
        className={classNames(
          fullScreen ? s.imageContainerFullScreen : s.imageContainer,
          "customScroll"
        )}
      >
        <a href={file} target="_blank" rel="noreferrer">
          {!pdfDocument && <Preloader fullScreen="center" />}
          {pdfDocument && <canvas id="canvas" ref={canvasRef} />}
        </a>
      </div>
      {Boolean(pdfDocument && pdfDocument.numPages) && (
        <nav className={s.buttonPdf}>
          <button
            className="btn"
            disabled={page === 1}
            onClick={() => setPage(page - 1)}
          >
            <GetIco icon="angle_arrow_left" />
          </button>
          <span className={"booble"}>
            {page}/{pdfDocument.numPages}
          </span>
          <button
            className="btn"
            disabled={page === pdfDocument.numPages}
            onClick={() => setPage(page + 1)}
          >
            <GetIco icon="angle_arrow_right" />
          </button>
          {presentation && fullScreen && (
            <button className="btn" onClick={closeFullscreen}>
              <img className={s.icoFull} src={closeFull} />
            </button>
          )}
          {presentation && !fullScreen && (
            <button className="btn" onClick={openFullscreen}>
              <img className={s.icoFull} src={openFull} />{" "}
            </button>
          )}
        </nav>
      )}
    </div>
  );
};